import _ from 'lodash';

export class Workspace {
  public id: string;
  public name: string;
  public createdBy: string;
  public createdOn: Date;
  public updatedBy: string;
  public updatedOn: Date;
  public workspaceLogoUrl: string;
  public workspaceHelpLink: string;
  public inheritPeopleFromOrg: boolean = false;
  public restrictEvaluations: boolean = false;

  constructor(
    id: string,
    name: string,
    createdBy: string,
    createdOn: Date,
    updatedBy: string,
    updatedOn: Date,
    workspaceLogoUrl: string,
    workspaceHelpLink: string,
    inheritPeopleFromOrg: boolean = false,
    restrictEvaluations: boolean = false
  ) {
    this.id = id;
    this.name = name;
    this.createdBy = createdBy;
    this.createdOn = createdOn;
    this.updatedBy = updatedBy;
    this.updatedOn = updatedOn;
    this.workspaceLogoUrl = workspaceLogoUrl;
    this.workspaceHelpLink = workspaceHelpLink;
    this.inheritPeopleFromOrg = inheritPeopleFromOrg;
    this.restrictEvaluations = restrictEvaluations;
  }

  static parse(obj: any): Workspace {
    let workspace = new Workspace(
      obj.id,
      obj.name,
      obj.createdBy,
      obj.createdOn,
      obj.updatedBy,
      obj.updatedOn,
      obj.workspaceLogoUrl,
      obj.workspaceHelpLink,
      obj.inheritPeopleFromOrg,
      obj.restrictEvaluations
    );

    return workspace;
  }
}
